import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import PayablesPage from "@/pages/PayablesPage";
import ReceivablesPage from "@/pages/ReceivablesPage";
import SuppliersPage from "@/pages/SuppliersPage";
import CostCentersPage from "@/pages/CostCentersPage";
import CategoriesPage from "@/pages/CategoriesPage";
import AccountsPage from "@/pages/AccountsPage";
import UsersPage from "@/pages/UsersPage";
import ProfilesPage from "@/pages/ProfilesPage";
import AuditPage from "@/pages/AuditPage";
import ReportsPage from "@/pages/ReportsPage";
import TransfersPage from "@/pages/TransfersPage";
import StatementsPage from "@/pages/StatementsPage";
import BudgetPage from "@/pages/BudgetPage";
import BudgetVsActualPage from "@/pages/BudgetVsActualPage";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<ProtectedRoute permission="dashboard.view"><DashboardPage /></ProtectedRoute>} />
              <Route path="/contas-a-pagar" element={<ProtectedRoute permission="payables.read"><PayablesPage /></ProtectedRoute>} />
              <Route path="/contas-a-receber" element={<ProtectedRoute permission="receivables.read"><ReceivablesPage /></ProtectedRoute>} />
              <Route path="/fornecedores" element={<ProtectedRoute permission="suppliers.read"><SuppliersPage /></ProtectedRoute>} />
              <Route path="/categorias" element={<ProtectedRoute permission="categories.read"><CategoriesPage /></ProtectedRoute>} />
              <Route path="/centros-de-custo" element={<ProtectedRoute permission="cost_centers.read"><CostCentersPage /></ProtectedRoute>} />
              <Route path="/contas-financeiras" element={<ProtectedRoute permission="accounts.read"><AccountsPage /></ProtectedRoute>} />
              <Route path="/orcamento" element={<ProtectedRoute permission="budget.view"><BudgetPage /></ProtectedRoute>} />
              <Route path="/orcado-x-realizado" element={<ProtectedRoute permission="budget.view"><BudgetVsActualPage /></ProtectedRoute>} />
              <Route path="/transferencias" element={<ProtectedRoute permission="financial_transfer.view"><TransfersPage /></ProtectedRoute>} />
              <Route path="/prestacao-de-contas" element={<ProtectedRoute permission="statement.view"><StatementsPage /></ProtectedRoute>} />
              <Route path="/relatorios" element={<ProtectedRoute permission="reports.view"><ReportsPage /></ProtectedRoute>} />
              <Route path="/usuarios" element={<ProtectedRoute permission="users.manage"><UsersPage /></ProtectedRoute>} />
              <Route path="/perfis" element={<ProtectedRoute permission="profiles.manage"><ProfilesPage /></ProtectedRoute>} />
              <Route path="/auditoria" element={<ProtectedRoute permission="audit.view"><AuditPage /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
